import { debugTracking } from '$lib/debug';
import { shouldTrack } from '$lib/global/tracking/helper';

import omit from 'lodash/omit';

import { integrationsWithIdsInEvents, integrationsWithOutIdsInEvents } from './integrations';
import { getTrackingService } from './TrackingServiceInstance';

export const trackQuantityEvent = (event: string, properties?: Record<string, unknown>) => {
    track(event, properties, {
        integrations: integrationsWithOutIdsInEvents,
    });
};

export const trackUniqueEvent = (event: string, properties: Record<string, unknown>) => {
    track(event, properties, {
        integrations: integrationsWithIdsInEvents,
    });
};

export const track = (
    event: string,
    properties: Record<string, unknown> | undefined,
    override: { integrations?: Record<string, boolean> } = {},
) => {
    debugTracking('-> V4 track request:', !!window.analytics, event, properties, override);

    if (!shouldTrack()) {
        return;
    }

    window.analytics?.track(event, properties, {
        ...override,
        context: generateContext().context,
    });
};

export const page = (pageName: string, properties: Record<string, unknown>) => {
    debugTracking('-> V4 page request:', !!window.analytics, pageName, properties);

    if (!shouldTrack()) {
        return;
    }

    window.analytics?.page(null, pageName, properties, {
        context: generateContext().context,
        integrations: integrationsWithOutIdsInEvents,
    });
};

export const identify = (traits?: Record<string, unknown>) => {
    debugTracking('-> V4 identify request:', !!window.analytics, traits);

    if (!shouldTrack()) {
        return;
    }

    window.analytics?.identify(getTrackingService().userId, traits, generateContext());
};

const generateContext = () => {
    const pipeline = getTrackingService().getEventContext();

    return {
        context: {
            perspective: omit(pipeline, 'trackingTitles'),
            dictionary: pipeline.trackingTitles,
            userAgent: window.navigator.userAgent,
            locale: window.navigator.language,
        },
    };
};

export default {
    track,
    page,
    identify,
};
